import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import customer_router from "./customer_router";
import admin_router from "./admin_router";
import login_router from "./login_router";
import store from "./store/store";
import Vuebar from "vuebar";
import "./plugins/base";
import VueSkycons from "vue-skycons";
import InstantSearch from "vue-instantsearch";
import JsonCSV from 'vue-json-csv';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
import PrimeVue from 'primevue/config';
Vue.use(PrimeVue);

Vue.use(Donut);

Vue.use(VueSweetalert2);

Vue.component('downloadCsv', JsonCSV);

Vue.use(VueSkycons, {
  color: "#1e88e5",
});
Vue.use(InstantSearch);
Vue.config.productionTip = false;
Vue.use(Vuebar);

Vue.prototype.$adminapiurl = '/';
Vue.prototype.$apiurl = '/';

let users = JSON.parse(localStorage.getItem("users"));
let user_type = '';
let site_id = '';
if(users != null){
  user_type = users[3]['user_type'];
  site_id = users[2]['site_id'];
}
if(user_type == ''){
  new Vue({
    vuetify,
    store,
    router:login_router,
    render: (h) => h(App),
  }).$mount("#app");
}
if(user_type == 'Customer'){
  new Vue({
    vuetify,
    store,
    router:customer_router,
    render: (h) => h(App),
  }).$mount("#app");
}else if(site_id == 0){
  new Vue({
    vuetify,
    store,
    router:admin_router,
    render: (h) => h(App),
  }).$mount("#app");
}else{
  new Vue({
    vuetify,
    store,
    router:router,
    render: (h) => h(App),
  }).$mount("#app");
}

